import script from "./ThirdIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./ThirdIhramPage.vue?vue&type=style&index=0&id=4e2a5eb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2a5eb2"]])

export default __exports__